<template>
  <div class="footer">
    <div class="level">
      <div class="level-left">
        <p class="level-item copyright">
          © 2018 CineFlick. <span>Todos los Derechos Reservados.</span>
        </p>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div class="buttons">
            <a class="button phone">
              <span class="icon">
                <PhoneIcon/>
              </span>
              <span>Teléfono: 2410-6550</span>
            </a>
            <a class="button whatsapp">
              <span class="icon">
                <WhatsAppIcon/>
              </span>
              <span>WhatsApp: 4253-0262</span>
            </a>
            <a class="button facebook">
              <span class="icon">
                <FacebookIcon/>
              </span>
              <span>Síguenos en Facebook</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PhoneIcon from 'vue-material-design-icons/Phone.vue';
import WhatsAppIcon from 'vue-material-design-icons/Whatsapp.vue';
import FacebookIcon from 'vue-material-design-icons/Facebook.vue';

export default {
  name: 'Footer',
  components: {
    PhoneIcon,
    WhatsAppIcon,
    FacebookIcon,
  },
};
</script>


<style lang="scss">
@import "~bulma/sass/utilities/initial-variables";
@import "~bulma/sass/utilities/functions";
@import "~bulma/sass/utilities/derived-variables";
@import "~bulma/sass/utilities/mixins";
@import "~@/sass/variables";

.footer{
  color: #fff;
  padding: 4%;

  @include until(640px) {
    .copyright, .buttons {
      flex-direction: column;
    }
  }

  @include from(640px) {
    .copyright span {
      margin-left: 5px;
    }
  }

  .buttons .button {
    background-color: rgba(0, 0, 0, 0.2);
    color: #fff;

    @include until(640px) {
      margin-bottom: 1rem;
      width: 100%;

      &:not(:last-child){
        margin-right: 0rem;
      }

      &:last-child{
        margin-bottom: 3rem;
      }
    }

    &.phone {
      $brilliant-cyan-invert: findColorInvert($brilliant-cyan);
      $button-focus-box-shadow-size: 0 0 0 0.125em;

      &:hover,
      &.is-hovered {
        background-color: $brilliant-cyan;
        border-color: transparent;
        color: $brilliant-cyan-invert;
      }

      &:focus,
      &.is-focused {
        background-color: darken($brilliant-cyan, 2.5%);
        border-color: transparent;
        color: $brilliant-cyan-invert;

        &:not(:active) {
          box-shadow: $button-focus-box-shadow-size rgba($brilliant-cyan, 0.25);
        }
      }

      &:active,
      &.is-active {
        background-color: darken($brilliant-cyan, 5%);
        border-color: transparent;
        color: $link-invert;
      }
    }

    &.whatsapp {
      $whatsapp-color: #128C7E;
      $whatsapp-color-invert: findColorInvert($whatsapp-color);
      $button-focus-box-shadow-size: 0 0 0 0.125em;

      &:hover,
      &.is-hovered {
        background-color: $whatsapp-color;
        border-color: transparent;
        color: $whatsapp-color-invert;
      }

      &:focus,
      &.is-focused {
        background-color: darken($whatsapp-color, 2.5%);
        border-color: transparent;
        color: $whatsapp-color-invert;

        &:not(:active) {
          box-shadow: $button-focus-box-shadow-size rgba($whatsapp-color, 0.25);
        }
      }

      &:active,
      &.is-active {
        background-color: darken($whatsapp-color, 5%);
        border-color: transparent;
        color: $whatsapp-color-invert;
      }
    }

    &.facebook {
      $facebook-color: #4267b2;
      $facebook-color-invert: findColorInvert($facebook-color);
      $button-focus-box-shadow-size: 0 0 0 0.125em;

      &:hover,
      &.is-hovered {
        background-color: $facebook-color;
        border-color: transparent;
        color: $facebook-color-invert;
      }

      &:focus,
      &.is-focused {
        background-color: darken($facebook-color, 2.5%);
        border-color: transparent;
        color: $facebook-color-invert;

        &:not(:active) {
          box-shadow: $button-focus-box-shadow-size rgba($facebook-color, 0.25);
        }
      }

      &:active,
      &.is-active {
        background-color: darken($facebook-color, 5%);
        border-color: transparent;
        color: $facebook-color-invert;
      }
    }
  }
}
</style>

